var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import moment from 'moment';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { instanceOf, number, object, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { relativeTimeFromNow } from '@philips-internal/oswald-ui-utils';
import RelativeTimeAPI from './relative-time-api.js';
let RelativeTime = class RelativeTime extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            interval: undefined,
            now: moment.utc(),
        };
        this.getRelativeTime = () => {
            const { date } = this.props;
            const { now } = this.state;
            return relativeTimeFromNow(date ?? now);
        };
    }
    componentDidMount() {
        const interval = setInterval(() => this.syncNow(), 30000);
        this.setState({ interval });
    }
    componentWillUnmount() {
        const interval = this.state.interval;
        if (interval) {
            clearInterval(interval);
        }
    }
    syncNow() {
        this.setState({ now: moment.utc() });
    }
    render() {
        const { className } = this.props;
        return (React.createElement("span", { className: className }, this.getRelativeTime()));
    }
};
RelativeTime.propTypes = {
    className: string,
    date: oneOfType([number, object, string, instanceOf(Date)]),
};
RelativeTime.defaultProps = {
    date: moment.utc(),
};
RelativeTime = __decorate([
    AwesomeComponent({ api: RelativeTimeAPI, type: ComponentType.DATA_DISPLAY })
], RelativeTime);
export default RelativeTime;
//# sourceMappingURL=relative-time.js.map